import React from 'react';

export default function SuccessBanner({ title, message, onClose }) {
  return (
    <div className="ps-card" style={{ borderLeft: '4px solid var(--success)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
        <div>
          <div style={{ fontWeight: 600 }}>{title}</div>
          <div style={{ color: 'var(--gray-600)', fontSize: '0.9rem' }}>{message}</div>
        </div>
        {onClose && (
          <button type="button" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
